import * as Yup from 'yup';

const Validation = Yup.object({
    name: Yup.string().required("Please enter name!"),
    imageUrl: Yup.string().required("Please upload logo!"),
    type: Yup.string().required("Please select type!"),
});

export default Validation;
